import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service'; // Adjust path if needed
import { map, take, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (route, state): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Perform real-time token validation instead of relying on cached observable value
  const hasValidToken = authService.getToken() !== null;
  
  if (hasValidToken) {
    return true; // Allow access
  } else {
    // Redirect to login page if not logged in or token expired
    console.log('AuthGuard: No valid token available, redirecting to /login');
    router.navigate(['/login']);
    return false; // Prevent access
  }
};